import { createRoute, redirect } from "@tanstack/react-router";

import { lazyWithRetry } from "@shared/lib/lazy";

import { renderProtectedRoute } from "@app/router/routeElements";
import { rootRoute } from "@app/router/rootRoute";

const shippingZones = lazyWithRetry(() => import("./routes/zones"));
const shippingZoneMethods = lazyWithRetry(
  () => import("./routes/zones/[zoneId]/methods"),
);
const packagingIndex = lazyWithRetry(() => import("./routes/packaging"));

const shippingZonesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/shipping/zones",
  component: () =>
    renderProtectedRoute(shippingZones, { requirePerms: ["shipping:read"] }),
});

const shippingIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/shipping",
  beforeLoad: () => {
    throw redirect({ to: "/shipping/zones", replace: true });
  },
  component: () => null,
});

const shippingZoneMethodsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/shipping/zones/$zoneId/methods",
  component: () =>
    renderProtectedRoute(shippingZoneMethods, {
      requirePerms: ["shipping:read"],
    }),
});

const packagingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/shipping/packaging",
  component: () =>
    renderProtectedRoute(packagingIndex, { requirePerms: ["shipping:read"] }),
});

export const shippingRouteTree = [
  shippingZonesRoute,
  shippingIndexRoute,
  shippingZoneMethodsRoute,
  packagingRoute,
];
